(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/lyckoplatsen/components/page-related/assets/react/components/charity-card-list.js') >= 0) return;  svs.modules.push('/modules/lyckoplatsen/components/page-related/assets/react/components/charity-card-list.js');

'use strict';

const _svs$lyckoplatsen$com = svs.lyckoplatsen.components.shared_charity.react.components,
  SelectCharityCard = _svs$lyckoplatsen$com.SelectCharityCard,
  SelectNoCharityCard = _svs$lyckoplatsen$com.SelectNoCharityCard,
  MoreCharitiesText = _svs$lyckoplatsen$com.MoreCharitiesText;
const SelectCharityHeader = svs.lyckoplatsen.components.page_related.react.components.SelectCharityHeader;
const activeCharitiesAtom = svs.lyckoplatsen.shared_charity.jotai.atoms.activeCharitiesAtom;
const _jotai = jotai,
  useAtomValue = _jotai.useAtomValue;
const CharityCardList = _ref => {
  let wagerId = _ref.wagerId;
  const activeCharities = useAtomValue(activeCharitiesAtom);
  if (!wagerId) {
    return null;
  }
  if (!(activeCharities !== null && activeCharities !== void 0 && activeCharities.length)) {
    return React.createElement("div", {
      className: "lp-page-related-charity-container"
    }, React.createElement(SelectCharityHeader, null));
  }
  return React.createElement("div", {
    className: "lp-page-related-charity-container"
  }, React.createElement(SelectCharityHeader, null), React.createElement("div", {
    className: "lp-charity-cards-container"
  }, activeCharities.map(c => React.createElement(SelectCharityCard, {
    charity: c,
    wagerId: wagerId,
    key: c.charityId,
    showButtonInFooter: true
  })), React.createElement(SelectNoCharityCard, null)), React.createElement(MoreCharitiesText, null));
};
setGlobal('svs.lyckoplatsen.components.page_related.react.components', {
  CharityCardList
});

 })(window);